export enum TemplateFileSuffix {
    Extension = "Code.ext.js",
    Code = "Code.js",
    Conf = "Conf.json",
    FormatCss = "Frmt.css",
    FormatJson = "Frmt.json"
}
